import * as angular from 'angular';
import * as _ from 'underscore';
import { IFoodPreference } from '../../products/models/index';
import { PopupService } from '../../../../app.common/modules/common/services/popup.service';

class PreferenceSelector  {
    static $inject = ['popupService',  '$translate'];
    preferences: IFoodPreference[];
    componentTitle: string;
    description: string;

    onChange: () => void;
    constructor (public  popupService: PopupService,
    private $translate: angular.translate.ITranslateService) {
    }

    ShowTooltip (message: string) {
         this.popupService.alert({
            title: this.componentTitle,
            okTxt: this.$translate.instant('close'),
            okClass: 'btn-success',
            content: message,
            classPopup: 'preferencePopup'
        });
    }
}

angular.module('naut').component('preferenceSelector', {
    template: require('./preference-selector.html'),
    controller: PreferenceSelector,
    controllerAs: 'vm',
    bindings: {
        'preferences': '<'  ,
        'componentTitle': '<',
        'description': '<',
        'onChange' : '&'
    }
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/foodPreferences/components/preference-selector.component.ts